export const ParsePhysicalValue = value =>
  value !== undefined ? Number(value) : null;
